import { render, staticRenderFns } from "./CreateConsent.vue?vue&type=template&id=96148d9c&scoped=true&"
import script from "./CreateConsent.vue?vue&type=script&lang=js&"
export * from "./CreateConsent.vue?vue&type=script&lang=js&"
import style0 from "./CreateConsent.vue?vue&type=style&index=0&id=96148d9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96148d9c",
  null
  
)

export default component.exports